import { configureStore } from '@reduxjs/toolkit'
import { searchBarSlice } from './components/search/search-bar.slice';
import { showDetailsSlice } from './components/show/show.slice';
import { recentShowsSlice } from './components/search/search.slice';
 
export const store = configureStore({
  reducer: {
    searchBar: searchBarSlice.reducer,
    showDetails: showDetailsSlice.reducer,
    recentShows: recentShowsSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;